import { render, staticRenderFns } from "./chart-pie.vue?vue&type=template&id=02ab9df8"
import script from "./chart-pie.vue?vue&type=script&lang=ts"
export * from "./chart-pie.vue?vue&type=script&lang=ts"
import style0 from "./chart-pie.vue?vue&type=style&index=0&id=02ab9df8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports